// extracted by mini-css-extract-plugin
module.exports = {"apps_choices":"CardApplications_apps_choices__31ig5"};